import { createSelector } from '@ngrx/store';
import { creditCardsState } from '../root';

export const isAddingCardRequest = createSelector(creditCardsState, (creditCards) => creditCards.add.isAdding || creditCards.token.isGettingToken);
